import React from "react";
import ReactDOM from "react-dom/client";
import "./css/index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FirstScreen from "./components/FirstTable";
import SecondScreen from "./components/SecondTable";
import Login from "./components/Login";
import Clasificator from "./components/Clasificator";
import General from "./components/general/General";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/login" element={<Login />} />
        <Route path="/clasificator" element={<Clasificator />} />
        <Route path="/general" element={<General />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
